module.exports = __webpack_public_path__ + "img/login-v2-dark.0f205541.svg";